import { Box, Heading, Text, Thumbnail } from '@wix/design-system';
import React from 'react';

export const DeploymentOption = ({
  title,
  subtitle,
  image,
  id,
  selected,
  setSelected,
}) => {
  return (
    <Thumbnail
      dataHook={id}
      selected={selected === id}
      onClick={() => setSelected(id)}
    >
      <Box padding="18px">
        <Box gap="12px" verticalAlign="middle">
          <img alt="" src={image} />
          <Box direction="vertical">
            <Heading size="tiny">{title}</Heading>
            <Box>
              <Text size="small" secondary>
                {subtitle}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </Thumbnail>
  );
};
